import { Controller } from "@hotwired/stimulus";
import { attachSummernote } from '../../../../../../scripts/summernoteHelper';

export default class AdditionalInformationController extends Controller {
    static targets = [
        "htmlField"
    ];

    readonly htmlFieldTargets!: HTMLElement[];

    connect() {
        this.setupSummerNoteHtmlEditor();
    }

    private setupSummerNoteHtmlEditor() {
        this.htmlFieldTargets.forEach(htmlField => attachSummernote($(htmlField)));
    }
}
